export var Urls = {
    ChangeStatus: "EventLogs/ChangeStatus"
};
